var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "../AttributeMap";
import { defaults, heapDefaults, immutable, keyValueTable } from "../../style";
import { deepAwaitMixin } from "../../mixins/DeepAwaitMixin";
// TODO: implement hide attributes
let ClassComponent = class ClassComponent extends deepAwaitMixin(LitElement) {
    get classAttributes() {
        return this.el.slice(3);
    }
    get superclassStr() {
        if (this.el[2].length > 0) {
            return `[extends ${this.el[2].join(', ')}]`;
        }
        else {
            return "";
        }
    }
    get name() {
        return this.el[1];
    }
    render() {
        return html `
            <label>
                ${this.name} class ${this.superclassStr}
            </label>
            <table>
                ${ // Hacky fix:  webcomponents are not allowed inside table, but templates are
        html `<tc-attribute-map .attributeEls=${this.classAttributes}></tc-attribute-map>`}
            </table>
        `;
    }
};
ClassComponent.styles = [defaults, heapDefaults, keyValueTable, immutable];
__decorate([
    property({ type: Array })
], ClassComponent.prototype, "el", void 0);
ClassComponent = __decorate([
    customElement('tc-class')
], ClassComponent);
export { ClassComponent };
//# sourceMappingURL=ClassComponent.js.map